import queryString, { StringifyOptions } from 'query-string';

const queryParams = (params: {[key: string]: any}, opts : StringifyOptions = {} ) =>
  queryString.stringify(params, { arrayFormat: 'index', ...opts });

export default queryParams;
